
import React from "react";
import TextInput, { TextInputProps } from "./TextInput";

interface CurrencyInputProps extends TextInputProps {
	  language: string;
}

const CurrencyInput = ( {value, language, ...props} : CurrencyInputProps ) => {

  const enforceCursorPosition = (input: HTMLInputElement) => {
    const cursorPosition = input.selectionStart || 0;
    if (cursorPosition >= input.value.length - 1) {
      requestAnimationFrame(() => {
        input.setSelectionRange(input.value.length - 1, input.value.length - 1);
      });
    }
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    requestAnimationFrame(() => {
      if (input.selectionStart && input.selectionStart >= input.value.length - 1) {
        input.setSelectionRange(input.value.length - 1, input.value.length - 1);
      }
    });
  };

  return (
    <>
      {language === "en" ? (
        <TextInput
          {...props}
          type="text"
          value={`$${value}`}
        />
      ) : (
        <TextInput
          {...props}
          type="text"
          value={`${value.replace(".", ",")}$`}
          onMouseDown={handleMouseDown}
          onFocus={(e) => enforceCursorPosition(e.currentTarget)}
          onInput={(e) => enforceCursorPosition(e.currentTarget)}
        />
      )}
    </>
  );
};

export default CurrencyInput;